<template>
    <section v-if="!isLoggedIn" class="c-login-page c-stretch-page u-flex-set u-flex--content-center u-flex--align-items-center">
        <div class="c-login-block">
            <form action="" class="c-form">

                <div class="o-page-row--medium u-text-align-center"><router-link to="/"><img class="[ c-logo ]" src="@/assets/images/logo.png" width="170px" height="79px"/></router-link></div>

                <v-form-row v-if="error">
                    <strong class="u-color-error-base">{{ error }}</strong>
                </v-form-row>

                <div class="u-font-extra-small u-margin-bottom u-text-align-right">
                    <span class="u-inline-block">{{ $t('customer.account.login.language_selection') }}</span>
                    <div class="select__language__options u-inline-block">
                        <a @click="changeLanguage('en')" :class="{'is-active': currentLanguage === 'en'}" href="#">English</a>
                        <a @click="changeLanguage('nl')" :class="{'is-active': currentLanguage === 'nl'}" href="#">Nederlands</a>
                        <a @click="changeLanguage('fr')" :class="{'is-active': currentLanguage === 'fr'}" href="#">Français</a>
                    </div>
                </div>

                <v-form-row>
                    <v-input v-model="creds.userName" :horizontal="false" name="userName" :fluid="true">
                        <slot slot="label">{{ $t('customer.account.login.username') }}</slot>
                    </v-input>
                </v-form-row>

                <v-form-row>
                    <v-input v-model="creds.password" :horizontal="false" type="password" name="password" :fluid="true">
                        <slot slot="label">{{ $t('customer.account.login.password') }}</slot>
                    </v-input>
                </v-form-row>

                <v-form-row>
                    <div class="c-form-item">
                        <v-label></v-label>
                        <button @click.prevent="submitForm" :disabled="btnDisabled" class="c-button c-button--alpha">{{ $t('customer.account.login.login') }}</button>

                        <router-link class="u-font-extra-small u-pull-right u-line-height-3-0" to="/password-forgot">
                            {{ $t('customer.account.login.forgot_password') }} 
                        </router-link>
                        <a class="u-margin-right u-font-extra-small u-pull-right u-line-height-3-0"
                           :href="`https://www.racompany.be/${currentLanguage}/node/1151`"
                           target="_blank">
                            {{ $t('customer.account.login.request_account') }}
                        </a>
                    </div>
                </v-form-row>
            </form>
        </div>
    </section>
</template>

<script>
    import VLoading from '@/components/Loading'
    import VBlocks from '@/components/blocks/Blocks'
    import Block from '@/components/blocks/Block'
    import PageHeader from '@/components/common/PageHeader'

    // Forms
    import VInput from '@/components/form/Input'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'

    export default {
        components: {
            PageHeader,
            VLoading,
            VLabel,
            VInput,
            VFormRow,
            Block,
        },
        data() {
            return {
                creds: {
                    grant_type: 'password',
                    userName: '',
                    password: ''
                },
                btnDisabled: true,
                error: null
            }
        },
        computed: {
            isLoggedIn() {
                return this.$store.getters.isLoggedIn;
            },
            isAdmin() {
                return this.$store.getters.isAdmin;
            },
            isSalesman() {
                return this.$store.getters.isSalesman;
            },
            isCustomer() {
                return this.$store.getters.isCustomer;
            },
            userRole() {
                if (this.isAdmin) {
                    return 'admin'
                } else if (this.isSalesman) {
                    return 'salesman'
                } else {
                    return 'customer'
                }
            },
            currentLanguage() {
                return this.$i18n.locale;
            },
            isDevelopment() {
                return process.env.NODE_ENV === 'development';
            }
        },
        watch: {
            "creds.userName"() {
                this.btnDisabled = this.creds.userName === '';
            }
        },
        methods: {
            submitForm() {
                this.btnDisabled = true;
                this.$store.dispatch('login', this.creds).then(() => {
                    var redirect = "/" + this.userRole;

                    if(this.$route.query.redirect)
                    {
                        redirect = this.$route.query.redirect
                    }
                    this.$router.push(redirect)
                }).catch((e) => {
                    this.error = this.$t('customer.account.login.failed');
                    this.btnDisabled = false;
                });
            },
            changeLanguage(locale) {
                // Set config files
                this.$i18n.locale = locale
                window.app.config.locale = locale

                // Set browser url
                history.pushState(null, null, "/"+locale+window.location.pathname.substring(3));
                window.location.reload(false);
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/private";

    .c-login-page {
        background-color: white;
    }

    .c-login-block {
        width: 100%;
        max-width: em(500px);
    }
</style>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-stretch-page {
        height: 100%;
    }

    .select__language__options {
        a {
            display: inline-block;
            padding: 0 3px;
            text-decoration: none;
            &:hover {
                text-decoration: underline;
            }
        }
        .is-active {
            color: $color-alpha;
            font-weight: bold;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/common/Login.vue